import { useState, useEffect } from "react";
import { fetchAccountsByLedger } from "../Services/AccountsByLedgerService";

export function useAccountsByLedger({ ledgerID, searchTerm }) {
  const [listAccounts, setListAccounts] = useState([]);
  const [page, setPage] = useState(1);

  // 🔑 NDAJE loading-un
  const [loadingInitial, setLoadingInitial] = useState(false); // për hapje / search
  const [loadingMore, setLoadingMore] = useState(false); // për scroll

  const [hasMore, setHasMore] = useState(true);

  // ============================
  // LOAD FILLESTAR + SEARCH
  // ============================
  useEffect(() => {
    setListAccounts([]);
    setPage(1);
    setHasMore(true);

    const controller = new AbortController();

    const loadInitial = async () => {
      try {
        setLoadingInitial(true); // ✅ vetëm këtu
        const data = await fetchAccountsByLedger({
          ledgerID: ledgerID,
          search: searchTerm || "",
          page: 1,
          pageSize: 50,
          signal: controller.signal,
        });

        setListAccounts(data);
        setHasMore(data.length === 50);
      } catch (err) {
        if (err.name !== "AbortError") console.error(err);
      } finally {
        setLoadingInitial(false);
      }
    };

    loadInitial();
    return () => controller.abort();
  }, [ledgerID, searchTerm]);

  // ============================
  // INFINITE SCROLL (PA reload)
  // ============================
  useEffect(() => {
    if (!hasMore || loadingMore || page === 1) return;

    const controller = new AbortController();

    const loadMore = async () => {
      try {
        setLoadingMore(true); // ⚠️ MOS prek Autocomplete
        const data = await fetchAccountsByLedger({
          ledgerID: ledgerID,
          search: searchTerm || "",
          page,
          pageSize: 50,
          signal: controller.signal,
        });

        setListAccounts((prev) => [...prev, ...data]);
        if (data.length < 50) setHasMore(false);
      } catch (err) {
        if (err.name !== "AbortError") console.error(err);
      } finally {
        setLoadingMore(false);
      }
    };

    loadMore();
    return () => controller.abort();
  }, [page]); // ✅ vetëm page

  return {
    listAccounts,
    loadingInitial,
    loadingMore,
    setPage,
    hasMore,
  };
}
